/**
 * @generated SignedSource<<778fd0f336a308b447deb039318992d6>>
 * @relayHash 5396db60d6140da4f42dcdadd893b844
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 67429d396a5d8a6ce0a5818b06123898ed719a41842dbdc6e11d4582876eda3a

import type { ConcreteRequest } from 'relay-runtime';
export type utils_twg_microsite_CurrentUser_Query$variables = Record<PropertyKey, never>;
export type utils_twg_microsite_CurrentUser_Query$data = {
  readonly me: {
    readonly user: {
      readonly accountId?: string;
      readonly createdAt?: AGG$DateTime | null;
      readonly email?: string | null;
      readonly extendedProfile?: {
        readonly jobTitle: string | null;
        readonly organization: string | null;
      } | null;
      readonly id?: string;
      readonly name?: string;
      readonly nickname?: string | null;
      readonly orgId?: string | null;
      readonly picture?: AGG$URL;
    } | null;
  };
};
export type utils_twg_microsite_CurrentUser_Query = {
  response: utils_twg_microsite_CurrentUser_Query$data;
  variables: utils_twg_microsite_CurrentUser_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "nickname"
},
v4 = {
  "kind": "ScalarField",
  "name": "picture"
},
v5 = {
  "kind": "ScalarField",
  "name": "email"
},
v6 = {
  "kind": "ScalarField",
  "name": "orgId"
},
v7 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v8 = {
  "concreteType": "AtlassianAccountUserExtendedProfile",
  "kind": "LinkedField",
  "name": "extendedProfile",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jobTitle"
    },
    {
      "kind": "ScalarField",
      "name": "organization"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "utils_twg_microsite_CurrentUser_Query",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "type": "AtlassianAccountUser"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "utils_twg_microsite_CurrentUser_Query",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v0/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "type": "AtlassianAccountUser"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "67429d396a5d8a6ce0a5818b06123898ed719a41842dbdc6e11d4582876eda3a",
    "metadata": {},
    "name": "utils_twg_microsite_CurrentUser_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0ccaaff8433b011ee0e24fbed3a153e4";

export default node;
